import React from "react";
import {withTranslation} from "react-i18next";
import stylesWelcome from "./SchedaSpecialeMalaria.module.css";
import DatiSegnalazioneMalaria from "./Sezioni/DatiSegnalazioneMalaria";
import DatiAnagraficiMalaria from "./Sezioni/DatiAnagraficiMalaria";
import InfoViaggioMalaria from "./Sezioni/InfoViaggioMalaria";
import DatiSanitariMalaria from "./Sezioni/DatiSanitariMalaria";
import EsitoMalaria from "./Sezioni/EsitoMalaria";
import EsitoTerapiaMalaria from "./Sezioni/EsitoTerapiaMalaria";
import QuestionarioMalaria from "./Sezioni/QuestionarioMalaria";

import OggettiUtili from "../../../../../../utils/OggettiUtili.json";
import SessioneUtente from "../../../../../../sessionManager/SessioneUtente";
import Ruoli from "../../../../../../utils/Ruoli";
import Utils from "../../../../../../utils/Utils";

class SchedaSpecialeMalaria extends React.Component {

    state = {
        schedaSpecialeMalaria: {
            datiSegnalazioneMalaria: {},
            datiAnagraficiMalaria: {},
            infoViaggioMalaria: {},
            datiSanitariMalaria: {},
            esitoMalaria: {},
            terapiaMalaria: {},
            questionarioMalaria: {}
        },
        validateMalaria: {
            datiAnagraficiMalaria: "",
            datiSanitariMalaria: "",
            esitoMalaria: "",
            infoViaggioMalaria: ""
        },
        corretto: [],
        oggettoBe: {}
    }

    constructor(props) {
        super(props)

        this.setSegnalazioneMalaria = this.setSegnalazioneMalaria.bind(this);
        this.setDatiAnagraficiMalaria = this.setDatiAnagraficiMalaria.bind(this);
        this.setInfoViaggioMalaria = this.setInfoViaggioMalaria.bind(this);
        this.setDatiSanitariMalaria = this.setDatiSanitariMalaria.bind(this);
        this.setEsitoMalaria = this.setEsitoMalaria.bind(this);
        this.setTerapiaMalaria = this.setTerapiaMalaria.bind(this);
        this.setQuestionarioMalaria = this.setQuestionarioMalaria.bind(this);
        this.controlloDati = this.controlloDati.bind(this);
        this.validate = this.validate.bind(this)
    }

    componentDidMount() {
        this.props.setSchedaSpecialeECorretto(this.state.oggettoBe, "", this.state.corretto)
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState !== this.state) {
            this.props.setSchedaSpecialeECorretto(this.state.oggettoBe, this.validate(), this.state.corretto)
        }
    }

    validate() {
        let validate = this.state.validateMalaria

        for (let key in validate) {
            if (validate[key]) {
                return validate[key]
            }
        }

        return ""
    }

    setSegnalazioneMalaria(datiSegnalazioneMalaria, datiSegnalazioneMalariaBe) {

        let schedaSpecialeMalaria = this.state.schedaSpecialeMalaria
        let oggettoBe = this.state.oggettoBe
        schedaSpecialeMalaria.datiSegnalazioneMalaria = datiSegnalazioneMalaria
        oggettoBe["datiSegnalazioneMalaria"] = datiSegnalazioneMalariaBe

        if (datiSegnalazioneMalaria !== undefined && datiSegnalazioneMalariaBe === undefined) {
            this.setState({schedaSpecialeMalaria: schedaSpecialeMalaria})
        } else if (datiSegnalazioneMalaria === undefined && datiSegnalazioneMalariaBe !== undefined) {
            this.setState({oggettoBe: oggettoBe})
        } else if (datiSegnalazioneMalaria !== undefined && datiSegnalazioneMalariaBe != undefined) {
            this.setState({schedaSpecialeMalaria: schedaSpecialeMalaria, oggettoBe: oggettoBe})
        }

        this.controlloDati();

    }

    setDatiAnagraficiMalaria(datiAnagraficiMalaria, validateAnagrafici, datiAnagraficiMalariaBe) {
        let schedaSpecialeMalaria = this.state.schedaSpecialeMalaria
        let oggettoBe = this.state.oggettoBe
        schedaSpecialeMalaria.datiAnagraficiMalaria = datiAnagraficiMalaria
        oggettoBe["datiAnagraficiMalaria"] = datiAnagraficiMalariaBe
        let validate = this.state.validateMalaria
        validate.datiAnagraficiMalaria = validateAnagrafici

        if (datiAnagraficiMalaria && datiAnagraficiMalariaBe && validateAnagrafici) {
            this.setState({
                schedaSpecialeMalaria: schedaSpecialeMalaria,
                oggettoBe: oggettoBe,
                validateMalaria: validate
            })
        } else if (!datiAnagraficiMalaria && datiAnagraficiMalariaBe && validateAnagrafici) {
            this.setState({oggettoBe: oggettoBe, validateMalaria: validate})
        } else if (datiAnagraficiMalaria && !datiAnagraficiMalariaBe && validateAnagrafici) {
            this.setState({schedaSpecialeMalaria: schedaSpecialeMalaria, validateMalaria: validate})
        } else if (datiAnagraficiMalaria && datiAnagraficiMalariaBe && !validateAnagrafici) {
            this.setState({oggettoBe: oggettoBe, schedaSpecialeMalaria: schedaSpecialeMalaria})
        } else if (datiAnagraficiMalaria && !datiAnagraficiMalariaBe && !validateAnagrafici) {
            this.setState({schedaSpecialeMalaria: schedaSpecialeMalaria})
        } else if (!datiAnagraficiMalaria && datiAnagraficiMalariaBe && !validateAnagrafici) {
            this.setState({oggettoBe: oggettoBe})
        } else if (!datiAnagraficiMalaria && !datiAnagraficiMalariaBe && validateAnagrafici) {
            this.setState({validateMalaria: validate})
        }

        this.controlloDati();
    }

    setInfoViaggioMalaria(dati, validateInfoViaggio, datiBe) {
        let schedaSpecialeMalaria = this.state.schedaSpecialeMalaria
        let oggettoBe = this.state.oggettoBe
        schedaSpecialeMalaria.infoViaggioMalaria = dati
        oggettoBe["infoViaggioMalaria"] = datiBe
        let validate = this.state.validateMalaria
        validate.infoViaggioMalaria = validateInfoViaggio

        if (dati && datiBe && validateInfoViaggio) {
            this.setState({
                schedaSpecialeMalaria: schedaSpecialeMalaria,
                oggettoBe: oggettoBe,
                validateMalaria: validate
            })
        } else if (!dati && datiBe && validateInfoViaggio) {
            this.setState({oggettoBe: oggettoBe, validateMalaria: validate})
        } else if (dati && !datiBe && validateInfoViaggio) {
            this.setState({schedaSpecialeMalaria: schedaSpecialeMalaria, validateMalaria: validate})
        } else if (dati && datiBe && !validateInfoViaggio) {
            this.setState({oggettoBe: oggettoBe, schedaSpecialeMalaria: schedaSpecialeMalaria})
        } else if (dati && !datiBe && !validateInfoViaggio) {
            this.setState({schedaSpecialeMalaria: schedaSpecialeMalaria})
        } else if (!dati && datiBe && !validateInfoViaggio) {
            this.setState({oggettoBe: oggettoBe})
        } else if (!dati && !datiBe && validateInfoViaggio) {
            this.setState({validateMalaria: validate})
        }

        this.controlloDati();

    }

    setDatiSanitariMalaria(dati, validateSanitari, datiBe) {
        let schedaSpecialeMalaria = this.state.schedaSpecialeMalaria
        let oggettoBe = this.state.oggettoBe
        schedaSpecialeMalaria.datiSanitariMalaria = dati
        oggettoBe["datiSanitariMalaria"] = datiBe
        let validate = this.state.validateMalaria
        validate.datiSanitariMalaria = validateSanitari

        if (dati && datiBe && validateSanitari) {
            this.setState({
                schedaSpecialeMalaria: schedaSpecialeMalaria,
                oggettoBe: oggettoBe,
                validateMalaria: validate
            })
        } else if (!dati && datiBe && validateSanitari) {
            this.setState({oggettoBe: oggettoBe, validateMalaria: validate})
        } else if (dati && !datiBe && validateSanitari) {
            this.setState({schedaSpecialeMalaria: schedaSpecialeMalaria, validateMalaria: validate})
        } else if (dati && datiBe && !validateSanitari) {
            this.setState({oggettoBe: oggettoBe, schedaSpecialeMalaria: schedaSpecialeMalaria})
        } else if (dati && !datiBe && !validateSanitari) {
            this.setState({schedaSpecialeMalaria: schedaSpecialeMalaria})
        } else if (!dati && datiBe && !validateSanitari) {
            this.setState({oggettoBe: oggettoBe})
        } else if (!dati && !datiBe && validateSanitari) {
            this.setState({validateMalaria: validate})
        }

        this.controlloDati();

    }

    setEsitoMalaria(dati, validateEsito, datiBe) {
        let schedaSpecialeMalaria = this.state.schedaSpecialeMalaria
        let oggettoBe = this.state.oggettoBe
        schedaSpecialeMalaria.esitoMalaria = dati
        oggettoBe["esitoMalaria"] = datiBe
        let validate = this.state.validateMalaria
        validate.infoViaggioMalaria = validateEsito

        if (dati && datiBe && validateEsito) {
            this.setState({
                schedaSpecialeMalaria: schedaSpecialeMalaria,
                oggettoBe: oggettoBe,
                validateMalaria: validate
            })
        } else if (!dati && datiBe && validateEsito) {
            this.setState({oggettoBe: oggettoBe, validateMalaria: validate})
        } else if (dati && !datiBe && validateEsito) {
            this.setState({schedaSpecialeMalaria: schedaSpecialeMalaria, validateMalaria: validate})
        } else if (dati && datiBe && !validateEsito) {
            this.setState({oggettoBe: oggettoBe, schedaSpecialeMalaria: schedaSpecialeMalaria})
        } else if (dati && !datiBe && !validateEsito) {
            this.setState({schedaSpecialeMalaria: schedaSpecialeMalaria})
        } else if (!dati && datiBe && !validateEsito) {
            this.setState({oggettoBe: oggettoBe})
        } else if (!dati && !datiBe && validateEsito) {
            this.setState({validateMalaria: validate})
        }

        this.controlloDati();

    }

    setTerapiaMalaria(dati, datiBe) {
        let schedaSpecialeMalaria = this.state.schedaSpecialeMalaria
        let oggettoBe = this.state.oggettoBe
        schedaSpecialeMalaria.terapiaMalaria = dati
        oggettoBe["terapiaMalaria"] = datiBe

        if (dati !== undefined && datiBe === undefined) {
            this.setState({schedaSpecialeMalaria: schedaSpecialeMalaria})
        } else if (dati === undefined && datiBe !== undefined) {
            this.setState({oggettoBe: oggettoBe})
        } else if (dati !== undefined && datiBe != undefined) {
            this.setState({schedaSpecialeMalaria: schedaSpecialeMalaria, oggettoBe: oggettoBe})
        }

        this.controlloDati();

    }

    setQuestionarioMalaria(dati, datiBe) {
        let schedaSpecialeMalaria = this.state.schedaSpecialeMalaria
        let oggettoBe = this.state.oggettoBe
        schedaSpecialeMalaria.questionarioMalaria = dati
        oggettoBe["questionarioMalaria"] = datiBe

        if (dati !== undefined && datiBe === undefined) {
            this.setState({schedaSpecialeMalaria: schedaSpecialeMalaria})
        } else if (dati === undefined && datiBe !== undefined) {
            this.setState({oggettoBe: oggettoBe})
        } else if (dati !== undefined && datiBe != undefined) {
            this.setState({schedaSpecialeMalaria: schedaSpecialeMalaria, oggettoBe: oggettoBe})
        }

        this.controlloDati();

    }

    controlloDati() {

        let schedaSpecialeMalaria = this.state.schedaSpecialeMalaria
        let textList = []

        if(schedaSpecialeMalaria.datiAnagraficiMalaria.corretto && schedaSpecialeMalaria.datiAnagraficiMalaria.corretto.length > 0){
            textList = textList.concat(Utils.eliminaNullArray(schedaSpecialeMalaria.datiAnagraficiMalaria.corretto))
        }
        if(schedaSpecialeMalaria.datiSanitariMalaria.corretto && schedaSpecialeMalaria.datiSanitariMalaria.corretto.length > 0){
            textList = textList.concat(Utils.eliminaNullArray(schedaSpecialeMalaria.datiSanitariMalaria.corretto))
        }
        if(schedaSpecialeMalaria.terapiaMalaria.corretto && schedaSpecialeMalaria.terapiaMalaria.corretto.length > 0){
            textList = textList.concat(Utils.eliminaNullArray(schedaSpecialeMalaria.terapiaMalaria.corretto))
        }
        if(schedaSpecialeMalaria.infoViaggioMalaria.corretto && schedaSpecialeMalaria.infoViaggioMalaria.corretto.length > 0){
            textList = textList.concat(Utils.eliminaNullArray(schedaSpecialeMalaria.infoViaggioMalaria.corretto))
        }
        if(schedaSpecialeMalaria.questionarioMalaria.corretto && schedaSpecialeMalaria.questionarioMalaria.corretto.length > 0){
            textList = textList.concat(Utils.eliminaNullArray(schedaSpecialeMalaria.questionarioMalaria.corretto))
        }
        this.setState({corretto: textList})
    }


    render() {

        const {t} = this.props;

        const campoObbligatorio = (

            <div className="col-lg-12" style={{paddingTop: "2rem"}}>
                <div className={stylesWelcome.mandatoryColor}> {t("DatiSegnalazioneAnagrafici.campoObbligatorio")}</div>
            </div>
        )





        return (
            <div style={{paddingTop: "2rem"}}
                 className={(this.props.segnalazioneCopia && this.props.segnalazioneCopia.migrazione) || SessioneUtente.getInstance().ruoliUtente === Ruoli.Operatore_Laboratorio.descrizione || (this.props.segnalazioneCopia.statoSegnalazione === OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice ||
                     this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice) ? "visualizzazione" : ""}>
                <fieldset
                    disabled={(this.props.segnalazioneCopia && this.props.segnalazioneCopia.migrazione) || SessioneUtente.getInstance().ruoliUtente === Ruoli.Operatore_Laboratorio.descrizione || (this.props.segnalazioneCopia.statoSegnalazione === OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice ||
                        this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice)}>

                    <DatiSegnalazioneMalaria
                        segnalazioneCopia={this.props.segnalazioneCopia ? this.props.segnalazioneCopia : ""}
                        setSegnalazioneMalaria={this.setSegnalazioneMalaria}></DatiSegnalazioneMalaria>
                    <div style={{paddingTop: "2rem"}}></div>
                    <DatiAnagraficiMalaria
                        datiPaziente={this.props.datiPaziente}
                        segnalazioneCopia={this.props.segnalazioneCopia ? this.props.segnalazioneCopia : ""}
                        setDatiAnagraficiMalaria={this.setDatiAnagraficiMalaria}></DatiAnagraficiMalaria>
                    <div style={{paddingTop: "2rem"}}></div>
                    <InfoViaggioMalaria
                        segnalazioneCopia={this.props.segnalazioneCopia ? this.props.segnalazioneCopia : ""}
                        setInfoViaggioMalaria={this.setInfoViaggioMalaria}></InfoViaggioMalaria>
                    <div style={{paddingTop: "2rem"}}></div>
                    <DatiSanitariMalaria
                        segnalazioneCopia={this.props.segnalazioneCopia ? this.props.segnalazioneCopia : ""}
                        setDatiSanitariMalaria={this.setDatiSanitariMalaria}></DatiSanitariMalaria>
                    <div style={{paddingTop: "2rem"}}></div>
                    <EsitoMalaria
                        datiPaziente={this.props.datiPaziente}
                        segnalazioneCopia={this.props.segnalazioneCopia ? this.props.segnalazioneCopia : ""}
                        setEsitoMalaria={this.setEsitoMalaria}></EsitoMalaria>
                    <div style={{paddingTop: "2rem"}}></div>
                    <EsitoTerapiaMalaria
                        segnalazioneCopia={this.props.segnalazioneCopia ? this.props.segnalazioneCopia : ""}
                        setTerapiaMalaria={this.setTerapiaMalaria}></EsitoTerapiaMalaria>
                    <div style={{paddingTop: "2rem"}}></div>
                    <QuestionarioMalaria
                        segnalazioneCopia={this.props.segnalazioneCopia ? this.props.segnalazioneCopia : ""}
                        setQuestionarioMalaria={this.setQuestionarioMalaria}></QuestionarioMalaria>
                    {campoObbligatorio}
                </fieldset>
            </div>
        )
    }

}

export default withTranslation('common')(SchedaSpecialeMalaria)
